module.exports = __webpack_public_path__ + "img/mc-skip-back.c5a7cecc.svg";